"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalizedDecimalSeparator = void 0;
var _react = require("react");
var _sdk = require("../../sdk");
var _hooks = require("../state/redux/hooks");
var _issueCustomFields = require("../state/redux/ducks/issueCustomFields");
var _featureFlags = require("../utils/featureFlags");
const useLocalizedDecimalSeparator = () => {
  const {
    value: isLocalizedNumericValues
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.LocalizedNumericValues);
  const issueCustomFieldEntitiesMap = (0, _hooks.useSelector)(_issueCustomFields.getCustomFieldEntitiesMap);

  // Numbers differ in their decimal separator in different locales (e.g. 1.1 vs 1,1)
  const getLocalizedDecimalSeparator = (0, _react.useCallback)(() => isLocalizedNumericValues ? 1.1.toLocaleString(navigator.language)[1] : ".", [isLocalizedNumericValues]);
  const formatLocalizedNumber = (0, _react.useCallback)(val => {
    const displayValue = (val !== null && val !== void 0 ? val : "").toString();
    if (!isLocalizedNumericValues) {
      return displayValue;
    }
    const localizedDecimalSeparator = getLocalizedDecimalSeparator();
    return displayValue.replace(/[,.]/g, localizedDecimalSeparator);
  }, [isLocalizedNumericValues, getLocalizedDecimalSeparator]);
  const sanitizeValue = (0, _react.useCallback)(val => getLocalizedDecimalSeparator() === "," ? val.replace(/,/g, ".") : val, [getLocalizedDecimalSeparator]);

  // onChange takes its input from the event input, which is a string that for some locales may have a comma as a
  // Decimal separator which would be an invalid number
  // This wrapper transforms the input into a valid number
  const onChangeLocalizedNumber = onChange => val => isLocalizedNumericValues ? onChange(sanitizeValue(val)) : onChange(val);
  const isNumericField = (0, _react.useCallback)(key => {
    const customField = issueCustomFieldEntitiesMap[key];
    return (customField === null || customField === void 0 ? void 0 : customField.dataType) === _sdk.IssueCustomAttributeType.Numeric;
  }, [issueCustomFieldEntitiesMap]);
  const shouldLocalizeNumericCustomFields = (0, _react.useCallback)(customAttributes => {
    if (!isLocalizedNumericValues || !customAttributes) {
      return false;
    }
    return true;
  }, [isLocalizedNumericValues]);
  const localizeNumericCustomFields = (0, _react.useCallback)(customAttributes => {
    if (!shouldLocalizeNumericCustomFields(customAttributes)) {
      return;
    }
    Object.keys(customAttributes).forEach(key => {
      if (isNumericField(key)) {
        customAttributes[key] = formatLocalizedNumber(customAttributes[key]);
      }
    });
  }, [shouldLocalizeNumericCustomFields, isNumericField, formatLocalizedNumber]);
  const sanitizeCustomAttributes = (0, _react.useCallback)(customAttributes => {
    if (!shouldLocalizeNumericCustomFields(customAttributes)) {
      return;
    }
    Object.keys(customAttributes).forEach(key => {
      if (isNumericField(key)) {
        customAttributes[key] = sanitizeValue(customAttributes[key]);
      }
    });
  }, [isNumericField, sanitizeValue, shouldLocalizeNumericCustomFields]);

  // some locales have ',' as decimal separator which is rejected by the server
  // this sanitizes the value before sending it to the server while allowing the  the rendered value to be localized
  const sanitizeIssueCustomAttributes = (0, _react.useCallback)(customAttributes => {
    if (!shouldLocalizeNumericCustomFields(customAttributes)) {
      return;
    }
    customAttributes.forEach(customAttribute => {
      if (isNumericField(customAttribute.attributeDefinitionId)) {
        customAttribute.value = sanitizeValue(customAttribute.value);
      }
    });
  }, [isNumericField, sanitizeValue, shouldLocalizeNumericCustomFields]);
  return {
    getLocalizedDecimalSeparator,
    formatLocalizedNumber,
    onChangeLocalizedNumber,
    sanitizeIssueCustomAttributes,
    sanitizeCustomAttributes,
    localizeNumericCustomFields
  };
};
exports.useLocalizedDecimalSeparator = useLocalizedDecimalSeparator;
//# sourceMappingURL=useLocalizedDecimalSeparator.js.map